import '@/js/dist/www.iichi.com/common';

import { createApp, h } from 'vue';
import { lazyCreateApp } from '@/js/lib/helper/lazy-mount';
import { linkify } from '@/js/lib/helper/linkify';
import { addFollowButton, addFollowRecommendIfItemLiked } from '@/js/lib/ui/follow-button';
import SocialShare from '@/js/components/common/ui/share.vue';
import CartButton from '@/js/components/listing/CartButton.vue';
import MessageButton from '@/js/components/listing/MessageButton.vue';
import SameCategoryItems from '@/js/components/listing/SameCategoryItems.vue';
import SendRequestButton from '@/js/components/listing/SendRequestButton.vue';
import SendRequestFinished from '@/js/components/listing/SendRequestFinished.vue';
import PhotoViewer from '@/js/components/www.iichi.com/organisms/PhotoViewer.vue';
import LikeButton from '@/js/components/www.iichi.com/pages/listing/item/LikeButton.vue';
import ShippingPlans from '@/js/components/www.iichi.com/pages/listing/item/ShippingPlans.vue';

interface Picture {
  path: string;
  alt: string;
  width: number;
  height: number;
  comment: string;
}

document.addEventListener('DOMContentLoaded', () => {
  if ('customElements' in window) {
    const photoViewerEl = document.querySelector('photo-viewer') as HTMLElement;
    createApp({
      render: () =>
        h(PhotoViewer, {
          pictures: JSON.parse(photoViewerEl.dataset.pictures!) as Picture[],
          hasThumbnail: photoViewerEl.dataset.hasThumbnail === 'true',
        }),
    }).mount(photoViewerEl);
  }

  const sameCategoryItemsEl = document.querySelector('same-category-items') as HTMLElement;
  lazyCreateApp(
    {
      render: () =>
        h(SameCategoryItems, {
          categoryId: Number(sameCategoryItemsEl.dataset.categoryId),
          isVintage: sameCategoryItemsEl.dataset.isVintage === 'true',
          price: Number(sameCategoryItemsEl.dataset.price),
        }),
    },
    sameCategoryItemsEl,
  );

  if ('IntersectionObserver' in window) {
    const cartButtonEl = document.querySelector('.cart-button') as HTMLDivElement;
    const breadEl = document.querySelector('.breadcrumb') as HTMLDivElement;
    const footerMetaEl = document.querySelector('.footer-meta') as HTMLDivElement;
    const cartButtonObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          cartButtonEl.classList.toggle('fixed', !entry.isIntersecting);
        });
      },
      {
        rootMargin: '20px 0px 600px 0px',
      },
    );
    cartButtonObserver.observe(footerMetaEl || breadEl); // アプリの場合はパンくずを監視する
    cartButtonObserver.observe(cartButtonEl); // 「カートに入れる」ボタンを後に監視する必要がある
  }

  const cartButtonEl = document.querySelector('cart-button') as HTMLElement;
  createApp({
    render: () =>
      h(CartButton, {
        itemId: Number(cartButtonEl.dataset.itemId),
        shopId: Number(cartButtonEl.dataset.shopId),
        stock: Number(cartButtonEl.dataset.stock),
        hasOption: Number(cartButtonEl.dataset.hasOption) as 1 | 0,
        isOnVacation: Number(cartButtonEl.dataset.isOnVacation) as 1 | 0,
        buttonLabel: cartButtonEl.dataset.buttonLabel,
      }),
  }).mount(cartButtonEl);

  const socialShareEl = document.querySelector('social-share') as HTMLElement;
  createApp({
    render: () =>
      h(SocialShare, {
        title: socialShareEl.dataset.title,
        url: socialShareEl.dataset.url,
      }),
  }).mount(socialShareEl);

  const messageButtonEl = document.querySelector('message-button') as HTMLElement;
  if (messageButtonEl) {
    createApp({
      render: () =>
        h(MessageButton, {
          disabled: messageButtonEl.dataset.disabled === 'true',
          itemId: Number(messageButtonEl.dataset.itemId),
          shopId: Number(messageButtonEl.dataset.shopId),
          subject: messageButtonEl.dataset.subject,
        }),
    }).mount(messageButtonEl);
  }

  const descriptionEl = document.querySelector('.item-description .text') as HTMLParagraphElement;
  descriptionEl.innerHTML = linkify(descriptionEl.innerHTML);

  const shippingPlansDetailsEl = document.querySelector('details.shipping-plans') as HTMLDetailsElement;
  const shippingPlansEl = document.querySelector('shipping-plans') as HTMLElement;
  let isShippingMethodFirstOpen = false;

  if (shippingPlansDetailsEl && shippingPlansEl) {
    shippingPlansDetailsEl.addEventListener('toggle', () => {
      if (shippingPlansDetailsEl.open && !isShippingMethodFirstOpen) {
        createApp({
          render: () =>
            h(ShippingPlans, {
              itemId: Number(shippingPlansEl.dataset.itemId),
            }),
        }).mount(shippingPlansEl);
        isShippingMethodFirstOpen = true;
      }
    });
  }

  const likeButtonEl = document.querySelector('.item-like like-button') as HTMLElement;
  if (likeButtonEl) {
    createApp({
      render: () =>
        h(LikeButton, {
          itemId: Number(likeButtonEl.dataset.itemId),
        }),
    }).mount(likeButtonEl);
  }

  addFollowButton().then(addFollowRecommendIfItemLiked);

  const sendRequestButtonEl = document.querySelector('send-request-button') as HTMLElement;
  if (sendRequestButtonEl) {
    createApp({
      render: () =>
        h(SendRequestButton, {
          itemId: Number(sendRequestButtonEl.dataset.itemId),
          shopId: Number(sendRequestButtonEl.dataset.shopId),
          isMe: Number(sendRequestButtonEl.dataset.isMe),
          isSubscribed: Number(sendRequestButtonEl.dataset.isSubscribed),
        }),
    }).mount(sendRequestButtonEl);
  }

  const sendRequestFinishedEl = document.querySelector('send-request-finished');
  if (sendRequestFinishedEl) {
    createApp(SendRequestFinished).mount(sendRequestFinishedEl);
  }
});
